import { render, staticRenderFns } from "./CartPurchaseBook.vue?vue&type=template&id=458582c2"
import script from "./CartPurchaseBook.vue?vue&type=script&lang=js"
export * from "./CartPurchaseBook.vue?vue&type=script&lang=js"
import style0 from "./CartPurchaseBook.vue?vue&type=style&index=0&id=458582c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports